// API snapshots are authoritative for offers and payments. Never infer VAT on
// historical orders or on the face value of wallet/credits.
export function isBusinessCustomer(role) {
  return role === "customer_business" || role === "customer_shop";
}

const cents = value => Math.round(value * 100);
const money = value => typeof value === "number" && Number.isFinite(value)
  && value >= 0 && Number.isSafeInteger(cents(value))
  && Math.abs(value * 100 - cents(value)) < 0.000001;

export function validPriceTax(value) {
  if (!value || typeof value !== "object") return false;
  const business = value.version === "business_net_v1"
    && value.audience === "business" && value.input_basis === "net";
  const privateTotal = value.version === "private_total_v1"
    && value.audience === "private" && value.input_basis === "total";
  return (business || privateTotal)
    && typeof value.vat_rate === "number" && Number.isFinite(value.vat_rate)
    && value.vat_rate >= 0 && value.vat_rate <= 1
    && [value.net_chf, value.vat_chf, value.total_chf].every(money)
    && cents(value.net_chf) + cents(value.vat_chf) === cents(value.total_chf);
}

export function formatVatRate(rate) {
  return typeof rate === "number" && Number.isFinite(rate) && rate >= 0 && rate <= 1
    ? `${(rate * 100).toLocaleString("it-CH", { maximumFractionDigits: 3 })}%`
    : "—";
}

// For the illustrative business savings calculator only. Checkout must use
// price_tax/charge_tax returned by the server, never this client-side estimate.
export function estimateTaxFromNet(net, rate) {
  if (typeof net !== "number" || !Number.isFinite(net) || net < 0
      || typeof rate !== "number" || !Number.isFinite(rate) || rate < 0 || rate > 1) return null;
  const netCents = Math.round((net + Number.EPSILON) * 100);
  const rateMillionths = Math.round(rate * 1000000);
  const vatCents = Math.round(netCents * rateMillionths / 1000000);
  if (!Number.isSafeInteger(netCents + vatCents)) return null;
  return { net_chf: netCents / 100, vat_chf: vatCents / 100,
    total_chf: (netCents + vatCents) / 100, vat_rate: rate };
}
